import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Sparkles } from 'lucide-react';
import { RELEASE_NOTES } from '../data/releaseNotes';
import { APP_VERSION } from '../utils/version';

const TYPE_STYLES = {
  new: { label: 'New', className: 'bg-emerald-100 text-emerald-800' },
  improved: { label: 'Improved', className: 'bg-blue-100 text-blue-800' },
  fixed: { label: 'Fixed', className: 'bg-amber-100 text-amber-800' },
};

export const WhatsNewDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-[560px]" data-testid="whats-new-dialog">
      <DialogHeader>
        <DialogTitle className="font-serif flex items-center gap-2">
          <Sparkles className="w-5 h-5 text-amber-600" />
          What's New
        </DialogTitle>
        <DialogDescription>You're on version {APP_VERSION}. Newest upgrades first.</DialogDescription>
      </DialogHeader>
      <ScrollArea className="max-h-[60vh] pr-3">
        <div className="space-y-6">
          {RELEASE_NOTES.map((release) => (
            <section key={release.version} data-testid={`release-${release.version}`}>
              <div className="flex items-baseline gap-2 border-b border-slate-200 pb-1 mb-2">
                <h3 className="font-semibold text-slate-900">Version {release.version}</h3>
                <span className="text-xs text-slate-500">{release.date}</span>
                {release.version === APP_VERSION && (
                  <span className="ml-auto text-[10px] uppercase tracking-wide font-semibold text-amber-700">Current</span>
                )}
              </div>
              <ul className="space-y-1.5">
                {release.changes.map((change) => (
                  <li key={change.text} className="flex items-start gap-2 text-sm text-slate-700">
                    <span className={`shrink-0 w-[64px] text-center mt-0.5 rounded px-1.5 py-0.5 text-[10px] font-semibold ${TYPE_STYLES[change.type].className}`}>
                      {TYPE_STYLES[change.type].label}
                    </span>
                    <span>{change.text}</span>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </ScrollArea>
    </DialogContent>
  </Dialog>
);
